module.exports = __webpack_public_path__ + "img/fire-flame-12.e2a0e992.png";